import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Video from './Video/index'
import { ReactComponent as Messaging } from './messaging.svg'
import { extend } from '../../utils/classes'

export class Header extends Component {
  render() {
    const baseClass = 'header'
    const container = extend(baseClass, 'container')
    const buttons = extend(container, 'buttons')
    return (
      <div className={baseClass}>
        <div className={container}>
          <h1 className={extend(container, 'title')}>
            CRM for all your messaging apps
          </h1>
          <div className={buttons}>
            <Button className={extend(buttons, 'action')}>Try for Free</Button>
            <Video parentClass={buttons} />
          </div>
          <Messaging className={extend(container, 'image')} />
        </div>
      </div>
    )
  }
}

export default Header
